import { ArrowRight, ArrowRightAlt, Close } from '@mui/icons-material';
import {
  Box,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useState } from 'react';
import { useConfig } from '../../../../Hooks/useConfig';

const SecondNavbarBox = styled('a')(({ theme }) => ({
  padding: theme.spacing(4, 16),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'url("/static/img/bar.png")',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  color: theme.palette.secondary.contrastText,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(4, 4),
  },
}));

const ImgTagSale = styled('img')(({ theme }) => ({
  width: theme.spacing(10.5),
}));
const ImgStar = styled('img')(({ theme }) => ({
  width: theme.spacing(60),
}));
const SecondNavbar = () => {
  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));

  const { panelUrl } = useConfig();
  return (
    <>
      <SecondNavbarBox href={`${panelUrl}/billing/pricing`}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: lgUp ? 'space-between' : 'center',
            width: '100%',
          }}
        >
          {lgUp ? <ImgStar src="/static/img/Sled.png" /> : null}
          <Typography
            sx={{
              fontSize: (theme) => (lgUp ? theme.spacing(5) : theme.spacing(4)),
              display: 'flex',
              alignItems: 'center',
              fontWeight: 700,
            }}
          >
            {' '}
            Merry Christmas{' '}
            <span
              style={{
                color: '#BA1A1A',
                marginLeft: '5px',
                fontWeight: 700,
                fontSize: (theme) =>
                  lgUp ? `${theme.spacing(7)} !important` : theme.spacing(4),
              }}
            >
              {' '}
              50% OFF{' '}
            </span>
            <ImgTagSale src="/static/img/sale_navbar.png" />
          </Typography>
          {lgUp ? (
            <Typography
              sx={{
                fontSize: '16px',
                display: 'flex',
                alignItems: 'center',
                fontWeight: 700,
              }}
            >
              {' '}
              Save 50% <ArrowRightAlt sx={{ ml: 3 }} />
            </Typography>
          ) : (
            ''
          )}
        </Box>
      </SecondNavbarBox>
    </>
  );
};
export default SecondNavbar;
